import { Stack, Typography } from "@mui/material";
import { memo } from 'react';

export type NoDataAvailableProps = {
  title?: string;
  subtitle?: string;
  cta?: JSX.Element;
};

export default memo(function NoDataAvailable({ subtitle, title, cta }: NoDataAvailableProps) {
  return (
    <Stack justifyContent={"center"} alignItems={"center"} p={4} bgcolor={"#f5f5f5"} borderRadius={1} gap={2}>
      <Stack alignItems={"center"} >
        <Typography color="primary" variant="h6" fontWeight={700}>{title || 'No Data Available'}</Typography>
        <Typography variant="body2" sx={{ color: 'text.secondary' }}>
          {subtitle || 'There is nothing to show at the moment. Please check back later'}
        </Typography>
      </Stack>
      {cta ? cta : null}
    </Stack>
  );
});
